import { useQuery, UseQueryResult } from '@tanstack/react-query';
import axios from 'axios';
import { IPAddressLocation } from '../types';

export const fetchIPAddressLocation = async (): Promise<IPAddressLocation | null> => {
  try {
    const ipApiResponse = await axios.get('https://ipapi.co/json');

    const ipData: IPAddressLocation = ipApiResponse.data;

    return ipData;
  } catch (err) {
    return null;
  }
};

export const useIPAddress = (): UseQueryResult<IPAddressLocation | null, Error> => {
  const query = useQuery({ queryKey: ['ipLookup'], queryFn: fetchIPAddressLocation });
  return query;
};
